import React from "react";
import ReactDOM from "react-dom";

// Fonts
import "fonts/Minecraftory/Minercraftory.ttf";

// Styles
import "index.css";

// App
import App from "App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
